const scrollAnimation = () => {
  if (window.innerWidth <= 1023) return;

  document.addEventListener('DOMContentLoaded', function () {
    const controller = new ScrollMagic.Controller();

    const section = document.querySelector('.fullscreen-slider');
    const sliderWrapper = section?.querySelector('.swiper-wrapper');
    const slides = section?.querySelectorAll('.swiper-slide');
    const totalSlides = slides?.length;

    if (!section || !sliderWrapper || !totalSlides) return;

    const swiper = section.querySelector('.js-pin-slider')?.swiper;
    if (!swiper) return;

    const slideHeight = window.innerHeight;
    const duration = slideHeight * totalSlides;

    const pinScene = new ScrollMagic.Scene({
      triggerElement: section,
      triggerHook: 0,
      duration: duration,
    })
        .setPin(section)
        .addTo(controller);

    pinScene.on('progress', (e) => {
      const targetSlide = Math.floor(e.progress * totalSlides);
      if (swiper.activeIndex !== targetSlide) {
        swiper.slideTo(targetSlide);
      }
    });
  });
};

export default scrollAnimation;
